import React from 'react';
import { Routes, Route, Outlet } from "react-router-dom";



function MaintainData() {
 
  return (
    <>
    <div className='errordiv'>
        <div className='error'>
            <h1>Maintain Data Page</h1>
        </div>
    </div>
</>
          
  );
}

export default MaintainData;
